// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";

// #####################################################

export const StyledMediaTypeLoginContainer = styled(Block)`
	display: flex;
	position: absolute;
	top: 0.75rem;
	left: 0.75rem;
`;

// #####################################################
